import React, { useEffect, useRef } from 'react';

const TOP_ROW = [
  { label: 'Sports', image: require('./images/sports.jpg') },
  { label: 'Cosplay', image: require('./images/cosplay.jpg') },
  { label: 'Music', image: require('./images/music.jpg') },
  { label: 'Finance', image: require('./images/finance.jpg') },
  { label: 'Food', image: require('./images/food.jpg') },
  { label: 'Marketing', image: require('./images/marketing.jpg') },
];

const BOTTOM_ROW = [
  { label: 'Fitness', image: require('./images/fitness.jpg') },
  { label: 'Golf', image: require('./images/golf.jpg') },
  { label: 'Wellness', image: require('./images/wellness.jpg') },
  { label: 'Sports Commentator', image: require('./images/commentator.jpg') },
  { label: 'Wrestling', image: require('./images/wrestling.jpg') },
  { label: 'Fashion', image: require('./images/fashion.jpg') },
];

export default function AltIndustryShowcase() {
  const sectionRef = useRef(null);
  const rafRef = useRef(0);
  const reducedMotionRef = useRef(false);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    reducedMotionRef.current = media.matches;
    const onMediaChange = (event) => {
      reducedMotionRef.current = event.matches;
    };

    if (media.addEventListener) {
      media.addEventListener('change', onMediaChange);
    } else {
      media.addListener(onMediaChange);
    }

    const updateProgress = () => {
      rafRef.current = 0;
      const node = sectionRef.current;
      if (!node) return;

      if (reducedMotionRef.current) {
        node.style.setProperty('--industry-progress', '0');
        return;
      }

      const rect = node.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      const total = rect.height + viewportHeight;
      const raw = (viewportHeight - rect.top) / total;
      const clamped = Math.min(1, Math.max(0, raw));
      node.style.setProperty('--industry-progress', String(clamped));
    };

    const onScrollOrResize = () => {
      if (rafRef.current) return;
      rafRef.current = window.requestAnimationFrame(updateProgress);
    };

    updateProgress();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    return () => {
      if (rafRef.current) {
        window.cancelAnimationFrame(rafRef.current);
      }
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
      if (media.removeEventListener) {
        media.removeEventListener('change', onMediaChange);
      } else {
        media.removeListener(onMediaChange);
      }
    };
  }, []);

  return (
    <section className="alt-industry" ref={sectionRef} aria-labelledby="alt-industry-heading">
      <div className="alt-industry__bg-lines" aria-hidden="true" />

      <div className="alt-industry__heading">
        <h2 id="alt-industry-heading" className="alt-industry__title">Every Industry.</h2>
        <p className="alt-industry__subtitle">One Platform.</p>
      </div>

      <div className="alt-industry__rows">
        <div className="alt-industry__row alt-industry__row--top">
          {TOP_ROW.map(({ label, image }) => (
            <article key={`top-${label}`} className="alt-industry__card">
              <img className="alt-industry__image" src={image} alt={label} loading="lazy" />
              <p className="alt-industry__label">{label}</p>
            </article>
          ))}
        </div>

        <div className="alt-industry__row alt-industry__row--bottom">
          {BOTTOM_ROW.map(({ label, image }) => (
            <article key={`bottom-${label}`} className="alt-industry__card">
              <img className="alt-industry__image" src={image} alt={label} loading="lazy" />
              <p className="alt-industry__label">{label}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
